import { render, staticRenderFns } from "./newImgCmp.vue?vue&type=template&id=6c45c880&scoped=true&"
import script from "./newImgCmp.vue?vue&type=script&lang=js&"
export * from "./newImgCmp.vue?vue&type=script&lang=js&"
import style0 from "./newImgCmp.vue?vue&type=style&index=0&id=6c45c880&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c45c880",
  null
  
)

export default component.exports